import React, { useState } from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import VaultHeaderLink from 'components/vaults/components/VaultHeaderLink';
import { useQRSync } from 'components/wallet/mobileSync/desktop/QrCodeSyncHeaderButton';
import { MAINTENANCE_MODE } from 'config/constants';

import { ItemWrapper } from './commonStyles';
import AccountValueMenuItem from './items/AccountValueItem';
import WalletMenuDropdownItem from './items/WalletMenuDropdownItem';
import walletSettingsItem from './items/WalletSettingsItem';
import MenuItemRenderer from './MenuItemRenderer';
import MenuLink from './MenuLink';

const Wrapper = styled.nav`
  display: flex;
  height: var(--header-height);
  /** Correct menu alignement */
  padding-top: 1px;
`;

const IconSvgComponentStyled = styled(MaterialSymbol)`
  vertical-align: middle;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export function HeaderMenuWallet() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const { qrSyncPlaceholder, showQrSyncModal } = useQRSync();

  return (
    <Wrapper>
      {!MAINTENANCE_MODE && (
        <>
          <VaultHeaderLink />
          <AccountValueMenuItem />
          {qrSyncPlaceholder}
          <MenuLink
            title={
              <IconSvgComponentStyled
                icon="qr_code_scanner"
                fontSize="small"
                color="white"
              />
            }
            onClick={showQrSyncModal}
            isTopMenu
            paddingRight="4px"
          />
        </>
      )}

      <ItemWrapper>
        <MenuItemRenderer
          menuItem={WalletMenuDropdownItem}
          linkProps={{ setDropdownOpen, isDropdownOpen }}
        />
      </ItemWrapper>
      <ItemWrapper>
        <MenuItemRenderer menuItem={walletSettingsItem} />
      </ItemWrapper>
    </Wrapper>
  );
}
